import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const accommodation: ApiFunc<`${typeof API.ACCOMMODATION}{id}`, 'get'> = data =>
  instance.get(`${API.ACCOMMODATION}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const accommodationList: ApiFunc<`${typeof API.ACCOMMODATION}`, 'get'> = data =>
  instance.get(API.ACCOMMODATION, { params: data })

export const accommodationCreate: ApiFunc<`${typeof API.ACCOMMODATION}`, 'post'> = data =>
  instance.post(API.ACCOMMODATION, data)

export const accommodationDelete: ApiFunc<`${typeof API.ACCOMMODATION}{id}`, 'delete'> = data =>
  instance.delete(`${API.ACCOMMODATION}${'id' in data ? prop('id', data) : data?.name}`)

export const accommodationStudentInfo: ApiFunc<`${typeof API.ACCOMMODATION_STUDENT_INFO}`, 'get'> = data =>
  instance.get(API.ACCOMMODATION_STUDENT_INFO, {
    params: data,
  })

export const accommodationChangeStatus: ApiFunc<`${typeof API.ACCOMMODATION_CHANGE_STATUS}`, 'put'> = data =>
  instance.put(API.ACCOMMODATION_CHANGE_STATUS, data)
